import { logger } from '@portal/logger'

import { getErrorMessage } from '@/shared/lib/error'

export type RenderGoogleButtonParams = {
    buttonRef: HTMLElement
    width?: number
    state: string
}

export function renderGoogleButton(params: RenderGoogleButtonParams) {
    try {
        window.google.accounts.id.renderButton(params.buttonRef, {
            type: 'standard',
            size: 'large',
            theme: 'filled_blue',
            text: 'continue_with',
            shape: 'rectangular',
            logo_alignment: 'left',
            width: params.width ?? 400,
            state: params.state,
        })
    } catch (err: unknown) {
        const errorMessage = getErrorMessage(err)
        logger.error(`[google-button] Unable to render Google button: ${errorMessage}`)
    }
}

export function showGoogleOneTap() {
    try {
        window.google.accounts.id.prompt()
    } catch (err: unknown) {
        const errorMessage = getErrorMessage(err)
        logger.error(`[google-button] Unable to show Google One Tap: ${errorMessage}`)
    }
}

export function hideGoogleOneTap() {
    try {
        window.google.accounts.id.cancel()
    } catch (err: unknown) {
        const errorMessage = getErrorMessage(err)
        logger.error(`[google-button] Unable to hide Google One Tap: ${errorMessage}`)
    }
}
